import React, { useState, useEffect } from "react";
import { Skeleton, Space, Row, Col, Divider } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import { limitWords } from "@utils/limitWords";
import MessageForm from "./form";

const GETMESSAGE = gql`
  query ($id: ID!) {
    getMessage(id: $id) {
     id
      createdAt
      updatedAt
      expiresAt
      isActive
      title
      body
      userIds
    }
  }
`;

function MessagesTableDetails({ id, onDataUpdate, onCloseDrawer }) {
    const [initialData, setInitialData] = useState({});
    const [formData, setFromData] = useState(null);

    const [getMessagesData, messageData] = useLazyQuery(GETMESSAGE, {
        fetchPolicy: "no-cache",
        onCompleted({ getMessage }) {
            const {
                id,
                createdAt,
                updatedAt,
                expiresAt,
                isActive,
                title,
                body,
                userIds
            } = getMessage;
            const messageData = {
                id,
                createdAt,
                updatedAt,
                expiresAt: expiresAt ? moment(expiresAt) : null,
                isActive,
                title,
                body,
                userIds: userIds.length ? userIds : "all"
            };
            setFromData(messageData);

            setInitialData({
                createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
                updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
                title,
                isActive
            });
        },
    });
    useEffect(() => {
        if (id) {
            getMessagesData({
                variables: {
                    id,
                },
            });
        }
    }, [id]);



    const { createdAt, updatedAt, title, isActive } = initialData;
    if (messageData.loading)
        return (
            <>
                <Skeleton active round />
                <br />
                <Skeleton active round />
            </>
        );

    return (
        <>
            <Row>
                <Col sm={12} xs={24}>
                    <Space align="">
                        <p>تاریخ ثبت: </p>
                        {createdAt}
                    </Space>
                </Col>
                <Col sm={12} xs={24}>
                    <Space align="">
                        <p>آخرین بروزرسانی: </p>
                        {updatedAt}
                    </Space>
                </Col>
            </Row>

            <Row>
                <Col sm={12} xs={24}>
                    <h3>پیام با عنوان "{limitWords(title, 5)}"</h3>
                </Col>
                <Col sm={12} xs={24}>
                    <h3>وضعیت:{" "}
                        {isActive ?
                            <span style={{ color: "#48c100", fontWeight: 500 }}>
                                فعال
                            </span>
                            : <span style={{ color: "#febb0b", fontWeight: 500 }}>
                                غیرفعال</span>
                        } </h3>
                </Col>
            </Row >
            <Divider />
            <MessageForm
                formData={formData}
                onDoUpdateData={onDataUpdate}
                onDoCloseDrawer={onCloseDrawer}
                id={id}
            />
        </>
    );
}

export default MessagesTableDetails;
